import { createSlice } from "@reduxjs/toolkit";

export const name = "container";

export const containerSlice = createSlice({
  name,
  initialState: {
    containerService: [],
    inforService: [],
    virshService: [],
    containerServiceLoading: false,
    inforServiceLoading: false,
    virshServiceLoading: false,
    liveResponsibles: { mailGateway: [], networkDefender: [] },
    liveResponsiblesLoading: false,
    containerServices: [],
    containerServicesLoading: false,
    updatePodName: "",
    updatePodLoading: false,
    showUpdateMessage: false,
    restartPodName: "",
    restartPodLoading: false,
    isAutoUpdateActive: false,
    isBackendServiceConnected: true,
    isUserServiceConnected: false,
    mgwResponsibleExists: false,
    ndResponsibleExists: false,
    agentResponsibleExists: false,
  },
  reducers: {
    RequestContainerService: (state) => {
      state.showUpdateMessage = false;
      state.containerServiceLoading = true;
    },
    SuccessContainerService: (state, action) => {
      state.containerService = action.payload;
      state.containerServiceLoading = false;
    },
    FailureContainerService: (state) => {
      state.containerService = [];
      state.containerServiceLoading = false;
    },
    RequestLiveResponsibles: (state) => {
      state.liveResponsiblesLoading = true;
    },
    SuccessLiveResponsibles: (state, action) => {
      state.liveResponsiblesLoading = false;
      state.liveResponsibles = action.payload;
    },
    FailureLiveResponsibles: (state) => {
      state.liveResponsiblesLoading = false;
      state.liveResponsibles = { mailGateway: [], networkDefender: [] };
    },
    RequestContainerServices: (state) => {
      state.containerServicesLoading = true;
    },
    RequestInforService: (state) => {
      state.inforServiceLoading = true;
    },
    RequestVirshService: (state) => {
      state.virshServiceLoading = true;
    },
    SuccessContainerServices: (state, action) => {
      state.containerServices = action.payload;
      state.containerServicesLoading = false;
    },
    FailureContainerServices: (state) => {
      state.containerServices = [];
      state.containerServicesLoading = false;
    },
    SuccessInforService: (state, action) => {
      state.inforService = action.payload;
      state.inforServiceLoading = false;
    },
    FailureInforService: (state) => {
      state.inforService = [];
      state.inforServiceLoading = false;
    },
    SuccessVirshService: (state, action) => {
      state.virshService = action.payload;
      state.virshServiceLoading = false;
    },
    FailureVirshService: (state) => {
      state.inforService = [];
      state.inforServiceLoading = false;
    },
    RequestPodUpdate: (state, action) => {
      state.updatePodName = action.payload.podName;
      state.updatePodLoading = true;
    },
    SuccessPodUpdate: (state) => {
      state.showUpdateMessage = true;
      state.containerServices = [];
      state.updatePodName = "";
      state.updatePodLoading = false;
    },
    FailurePodUpdate: (state) => {
      state.updatePodName = "";
      state.updatePodLoading = false;
    },
    RequestPodRestart: (state, action) => {
      state.restartPodName = action.payload.podName;
      state.restartPodLoading = true;
    },
    SuccessPodRestart: (state) => {
      state.restartPodName = "";
      state.restartPodLoading = false;
    },
    FailurePodRestart: (state) => {
      state.restartPodName = "";
      state.restartPodLoading = false;
    },
    RequestGetAutoUpdateState: (state) => {},
    SuccessGetAutoUpdateState: (state, action) => {
      state.isAutoUpdateActive = action.payload;
    },
    FailureGetAutoUpdateState: (state) => {},
    RequestSetAutoUpdateState: (state) => {},
    SuccessSetAutoUpdateState: (state) => {},
    FailureSetAutoUpdateState: (state) => {},
    RequestBackendServiceConnected: (state) => {},
    SuccessBackendServiceConnected: (state) => {
      state.isBackendServiceConnected = true;
    },
    FailureBackendServiceConnected: (state) => {
      state.isBackendServiceConnected = false;
    },
    RequestUserServiceConnected: (state) => {},
    SuccessUserServiceConnected: (state) => {
      state.isUserServiceConnected = true;
    },
    FailureUserServiceConnected: (state) => {
      state.isUserServiceConnected = false;
    },
    RequestCheckExistingResponsibles: (state) => {},
    SuccessCheckExistingResponsibles: (state, action) => {
      state.mgwResponsibleExists = action.payload.mgw;
      state.ndResponsibleExists = action.payload.nd;
      state.agentResponsibleExists = action.payload.agent;
    },
    FailureCheckExistingResponsibles: (state) => {
      state.mgwResponsibleExists = false;
      state.ndResponsibleExists = false;
      state.agentResponsibleExists = false;
    },
  },
});

export default containerSlice;
